// E4 (47007 W7): the served event preview of one money door, debounced, stale-proof. Returns { pv, refusal } and null/null while there is nothing to ask or the route is absent
// (a 404 turns the hook off for the session: the door falls back to its client before / after).
import { useEffect, useState } from 'react';
import api from '../../../services/api';
import { isMissingPreview } from '../orderPage/moneyDoorModel.mjs';

let MISSING = false;
export function useEventPreview(op, body) {
  const [st, setSt] = useState({ pv: null, refusal: null });
  const sig = body && !MISSING ? JSON.stringify(body) : '';
  useEffect(() => {
    if (!sig) { setSt({ pv: null, refusal: null }); return undefined; }
    let live = true;
    const h = setTimeout(() => {
      Promise.resolve().then(() => api.eventPreview(op, JSON.parse(sig))).then(r => {
        if (!live) return;
        if (isMissingPreview(r)) { MISSING = true; setSt({ pv: null, refusal: null }); return; }
        // E4 (47011): a non-admin gets the redacted shape (permitted only): no figures, no split, the permission reason as the refusal
        if (r && r.ok && r.data && r.data.redacted) { setSt({ pv: null, refusal: r.data.permitted ? { code: r.data.permitted.code, error: r.data.permitted.error, error_fr: r.data.permitted.error_fr } : null, redacted: true }); return; }
        if (r && r.ok && r.data) setSt({ pv: r.data.order ? r.data : null, refusal: r.data.allowed === false && r.data.refusal ? r.data.refusal : null });
        else setSt({ pv: null, refusal: r && r.data && r.data.code ? r.data : null });
      }).catch(() => { if (live) setSt({ pv: null, refusal: null }); });
    }, 350);
    return () => { live = false; clearTimeout(h); };
  }, [op, sig]);
  return st;
}
